import * as React from 'react';
import { RoundButton } from '@cian/ui-kit/button';
import { IconActionFullscreen16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';
import { trackOpenFullscreenGallery } from './tracking';
import { FullscreenGallery } from '../../components/FullscreenGallery';
import { Content } from '../../components/FullscreenGallery/Content';
import { IApplicationState } from '../../types/redux';
import { FullscreenGalleryHeaderContainer } from '../FullscreenGalleryHeader';

export function FullscreenGalleryContainer() {
  const [isOpened, setOpenedState] = React.useState(false);

  const gallery = useSelector((state: IApplicationState) => state.galleryMedia);

  const onButtonClick = React.useCallback(() => {
    setOpenedState(true);
    trackOpenFullscreenGallery();
  }, []);

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, []);

  return (
    <>
      <RoundButton
        theme="dark"
        size="M"
        icon={<IconActionFullscreen16 color="icon-inverted-default" />}
        onClick={onButtonClick}
        data-testid="FullscreenGalleryButton"
        title="Открыть галерею"
      />
      {isOpened && (
        <FullscreenGallery
          onClose={onClose}
          header={<FullscreenGalleryHeaderContainer onClose={onClose} />}
          content={<Content gallery={gallery} />}
        />
      )}
    </>
  );
}
